import script from "./PurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseDetailsPopup.vue?vue&type=style&index=0&id=3fdca4ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdca4ea"]])

export default __exports__